import React, { useContext, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Row, Col, Container, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faChartLine, 
  faMobileAlt, 
  faUsers,
} from '@fortawesome/free-solid-svg-icons';

import AuthContext from '../../Context/authContext';
import Footer from '../../Layouts/Footer';
import BusinessPageImg from '../../Assets/Images/business_pageImg.svg';

import './style.scss';


const SectionOne = () => {
  const navigate = useNavigate();

  return (
    <div id="bisSectionOne">
      <Container className="bisSectionOneContainer">
        <Row className="bisSectionOneRow top-50 position-relative align-middle">
          <Col xs={12} lg={5}>
            <h2>
              Transform Your Hospitality Business
            </h2>
            <p>
              Jamlyf streamlines operations, and maximizes revenue. 
              Reduce theft, optimize inventory, and deliver exceptional customer experiences that 
              keep patrons coming back.
            </p>
            <Button
              className='applyButton'
              onClick={() => navigate('/signup')}
            >
              Get Started
            </Button>
          </Col>
          <Col xs={12} lg={7}>
            <img src={BusinessPageImg} alt="Jamlyf Business Dashboard" />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const SectionTwo = () => {
  const navigate = useNavigate();
  return (
    <div id="bisSectionTwo">
      <Container>
        <Row className="row1">
          <Col align="center">
            <h2>
              Built for Modern Hospitality Businesses
            </h2>
            <p>
              From restaurants to nightclubs, Jamlyf gives you the tools to increase efficiency, 
              reduce losses, and grow your revenue. Join the future of hospitality management.
            </p>
          </Col>
        </Row>
        <Row className="row2">
          <Col xs={12} lg={4}>
            <FontAwesomeIcon icon={faChartLine} size="2x" />
            <h3>Boost Revenue</h3>
            <p>
              Serve more customers faster with streamlined ordering.
              We don't install any specialized devices that will cost you money.
              All functionalities can be accessed from a PC and or mobile phone.
            </p>
          </Col>
          <Col xs={12} lg={4}>
            <FontAwesomeIcon icon={faMobileAlt} size="2x" />
            <h3>Seamless Operations</h3>
            <p>
              Manage multiple locations, staff, and menus from one dashboard. Your team gets 
              instant order notifications, reducing wait times and improving table turnover.
            </p>
          </Col>
          <Col xs={12} lg={4}>
            <FontAwesomeIcon icon={faUsers} size="2x" />
            <h3>Customer Insights</h3>
            <p>
              Understand spending patterns, peak hours, and popular items. Data-driven analytics 
              help you make smarter decisions about staffing, inventory, and promotions.
            </p>
          </Col>
        </Row>
        <Row className="row3">
          <Col align="center">
            <Button
              className="applyButton2 business"
              onClick={() => navigate('/signup')}
            >
              Join Jamlyf Today
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const BusinessPage = () => {
  const { setIsAdmin } = useContext(AuthContext);

  useEffect(() => {
    setIsAdmin(true);
  }, [setIsAdmin]);

  return (
    <div>
      <SectionOne />
      <SectionTwo />
      <Footer />
    </div>
  );
};

export default BusinessPage;
